import { BoxCta } from './common/box-cta';
import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { ModelEntityType } from '@upright/common/model/input/types';
import { Link } from '@upright/ui/common/generic/components/primer-custom/link';
import { getModelEntityUrl } from '@upright/ui/untidy/urls';

const defaultExamples: Array<{ type: ModelEntityType; id: string; name: string; descriptor?: string }> = [
  {
    type: ModelEntityType.GROUP,
    id: 'g-a4f6d3bb-d59d-47f5-91ce-e591d15188b5',
    name: 'Vanguard Total Stock Market ETF',
  },
  {
    type: ModelEntityType.GROUP,
    id: 'g-f21356cb-6d05-4e6d-bee8-1bbcc8c7aa23',
    name: 'Blackstone Growth I',
  },
  {
    type: ModelEntityType.GROUP,
    id: 'g-79ebfdd8-0ad6-4abf-a284-66b9ac26426b',
    name: 'Atomico V',
  },
];

export function EmptyStateExampleFundProfilesCTA(props: {
  examples?: Array<{ type: ModelEntityType; id: string; name: string; descriptor?: string }>;
  lensTypeToLinkTo?: ImpactLensType;
  profileListText?: string;
}) {
  const examples = props.examples ?? defaultExamples;
  return (
    <BoxCta title="View sample profiles">
      {props.profileListText ?? 'To see what the full data looks like, please see the example profiles:'}{' '}
      {examples.map((ref, index) => {
        return (
          <span key={ref.id}>
            <Link indicator="underline" to={getModelEntityUrl(ref.type, ref.id, ref.name, props.lensTypeToLinkTo)}>
              {ref.name}
            </Link>
            {ref.descriptor ? ` ${ref.descriptor}` : undefined}
            {index < examples.length - 1 ? ', ' : undefined}
          </span>
        );
      })}
      .
    </BoxCta>
  );
}
